import React from "react";

/** string used to separate two answers in a answer block */
export const TABLE_INPUT_SEPARATOR = ";";
export const TABLE_INPUT_START_CHAR = "{";
export const TABLE_INPUT_END_CHAR = "}";
export const tableInputFormat = "&INPUT&";

export const TABLE_STANDARD_TEMPLATE = [
  {
    id: 1,
    col1: "",
    col2: "",
    col3: "",
  },
  {
    id: 2,
    col1: "",
    col2: "",
    col3: "",
  },
  {
    id: 3,
    col1: "",
    col2: "",
    col3: "",
  },
];

export const TABLE_QUESTION_SETTINGS = [
  {
    key: "ROW",
    value: "ROW",
    label: "worksheet:row_as_header",
  },
  {
    value: "COL",
    key: "COL",
    label: "worksheet:col_as_header",
  },
];
